/**
 * @flow
 * @relayHash b32d9a6dd11ba01b9be556b2d61116ff
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedReturnsContainer_returnOrders$ref = any;
export type ReturnOrderSortField = "CREATED_AT" | "CUSTOMER" | "ORDER_NUMBER" | "REASON" | "RETURN_NUMBER" | "RETURN_TYPE" | "STATUS" | "UPDATED_AT";
export type ReturnOrderStatus = "AUTHORIZED" | "CLOSED" | "RECEIVED" | "REJECTED" | "REQUESTED";
export type ReturnReason = "CUSTOMER_CHANGED_MIND" | "DAMAGED" | "DEFECTIVE" | "NOT_AS_DESCRIBED" | "OTHER" | "WRONG_ITEM";
export type ReturnType = "CREDIT" | "REFUND" | "REPAIR" | "REPLACEMENT";
export type SortDirection = "ASC" | "DESC";
export type ReturnOrderSort = {|
  field: ReturnOrderSortField,
  direction: SortDirection,
|};
export type PaginatedReturnsContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?ReturnOrderSort,
  statuses?: ?$ReadOnlyArray<ReturnOrderStatus>,
  returnTypes?: ?$ReadOnlyArray<ReturnType>,
  reasons?: ?$ReadOnlyArray<ReturnReason>,
  customerIds?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
|};
export type PaginatedReturnsContainerQueryResponse = {|
  +$fragmentRefs: PaginatedReturnsContainer_returnOrders$ref
|};
export type PaginatedReturnsContainerQuery = {|
  variables: PaginatedReturnsContainerQueryVariables,
  response: PaginatedReturnsContainerQueryResponse,
|};
*/


/*
query PaginatedReturnsContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: ReturnOrderSort
  $statuses: [ReturnOrderStatus!]
  $returnTypes: [ReturnType!]
  $reasons: [ReturnReason!]
  $customerIds: [ID!]
  $orderIds: [ID!]
) {
  ...PaginatedReturnsContainer_returnOrders_4g5lv4
}

fragment PaginatedReturnsContainer_returnOrders_4g5lv4 on Query {
  returnOrders(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, returnTypes: $returnTypes, reasons: $reasons, customerIds: $customerIds, orderIds: $orderIds) {
    edges {
      cursor
      ...ReturnsTable_returnOrderEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReturnsTable_returnOrderEdges on ReturnOrderEdge {
  node {
    id
    returnNumber
    status
    returnType
    reason
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ReturnOrderSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[ReturnOrderStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "returnTypes",
    "type": "[ReturnType!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reasons",
    "type": "[ReturnReason!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v2 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v3 = {
  "kind": "Variable",
  "name": "reasons",
  "variableName": "reasons"
},
v4 = {
  "kind": "Variable",
  "name": "returnTypes",
  "variableName": "returnTypes"
},
v5 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v6 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v7 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedReturnsContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedReturnsContainer_returnOrders",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedReturnsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "returnOrders",
        "storageKey": null,
        "args": (v8/*: any*/),
        "concreteType": "ReturnOrderConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ReturnOrderEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ReturnOrder",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "returnNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "returnType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "reason",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Customer",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "returnOrders",
        "args": (v8/*: any*/),
        "handle": "connection",
        "key": "PaginatedReturnsContainer_returnOrders",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedReturnsContainerQuery",
    "id": null,
    "text": "query PaginatedReturnsContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: ReturnOrderSort\n  $statuses: [ReturnOrderStatus!]\n  $returnTypes: [ReturnType!]\n  $reasons: [ReturnReason!]\n  $customerIds: [ID!]\n  $orderIds: [ID!]\n) {\n  ...PaginatedReturnsContainer_returnOrders_4g5lv4\n}\n\nfragment PaginatedReturnsContainer_returnOrders_4g5lv4 on Query {\n  returnOrders(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, returnTypes: $returnTypes, reasons: $reasons, customerIds: $customerIds, orderIds: $orderIds) {\n    edges {\n      cursor\n      ...ReturnsTable_returnOrderEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReturnsTable_returnOrderEdges on ReturnOrderEdge {\n  node {\n    id\n    returnNumber\n    status\n    returnType\n    reason\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a35e91bf195d34b66e085d0a2d7da1d9';
module.exports = node;
